<template>
  <div class="accordion-container">
    <div class="accordion" :class="{ active: isOpen }" @click="toggleAccordion">
      {{ title }}
      <ph-plus-circle v-if="!isOpen" />
      <ph-minus-circle v-else />
    </div>

    <Container
      class="panel"
      ref="panel"
      :style="maxHeight"
      behaviour="copy"
      group-name="markdown"
      :get-child-payload="getBlock"
    >
      <Draggable v-for="(block, i) in blocks" :key="i">
        <block :name="block.name" :icon="block.icon" :tooltip="block.tooltip" />
      </Draggable>
    </Container>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import Block from "./Block.vue";
import { PhPlusCircle, PhMinusCircle } from "phosphor-vue";

export default {
  name: "Accordion",
  components: { Container, Draggable, Block, PhPlusCircle, PhMinusCircle },
  provide: {
    color: "white",
    size: 21,
    weight: "regular",
    mirrored: false,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    blocks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      height: 0,
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) this.height = this.$refs.panel.$el.scrollHeight;
      else this.height = 0;
    },
    getBlock(index) {
      let block = {
        type: this.blocks[index].type,
        name: this.blocks[index].name,
        image: this.blocks[index].image,
        code: this.blocks[index].code,
        tooltip: this.blocks[index].tooltip,
      };
      if (block.type == "list") {
        block.value = [
          {
            prefix: this.blocks[index].value[0].prefix,
            indent: this.blocks[index].value[0].indent,
            value: this.blocks[index].value[0].value,
          },
        ];
      } else block.value = this.blocks[index].value;

      return block;
    },
  },
  computed: {
    maxHeight() {
      return `max-height: ${this.height}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  background-color: #343233;
  color: rgb(255, 255, 255);
  cursor: pointer;
  padding: 0.5rem;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
  font-family: "Rubik";
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: lighten(#343233, 5%);
  }
}

.accordion-container {
  margin: 0.3rem 0;
}

.active {
  background-color: lighten(#343233, 12%);
}

.panel {
  padding: 0 0.3rem;
  background-color: transparent;
  transition: max-height 0.2s ease-out;
  overflow: hidden;
  max-height: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-height: 0;
  min-width: 0;

  & > :first-child {
    margin: 0;
  }
}
</style>
